import styled from 'styled-components'

export const Offers = styled.div`
  .additional {
    padding-bottom: 30px;

    > div > p {
      margin-top: 10px;
    }
  }
`
